import { motion } from "framer-motion";
import { ArrowUpRight, Eye, Heart, Play } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const PERSONAL_BRAND = [
  {
    handle: "@shreyeeaa",
    profile: "https://www.instagram.com/shreyeeaa/",
    screenshot: "/profile-shreyeeaa.jpg",
    reels: [
      { url: "https://www.instagram.com/p/DbQX3_kztiJ/", views: "10.4M", likes: "206K", thumb: "/reel-shreyeeaa-1.png" },
      { url: "https://www.instagram.com/p/DctiGsQzW6m/", views: "275K", likes: "7.2K", thumb: "/reel-shreyeeaa-2.png" },
    ],
  },
  {
    handle: "@aaashishnaik",
    profile: "https://www.instagram.com/aaashishnaik/",
    screenshot: "/profile-aaashishnaik.jpg",
    reels: [
      { url: "https://www.instagram.com/p/Db29_ivJPxK/", views: "265K", likes: "17.2K", thumb: "/reel-aaashishnaik-1.png" },
      { url: "https://www.instagram.com/p/DaFrRv2MMXE/", views: "316K", likes: "8.7K", thumb: "/reel-aaashishnaik-2.jpg" },
      { url: "https://www.instagram.com/p/Dcn1X5cpvWp/", views: "120K", likes: "5.2K", thumb: "/reel-aaashishnaik-4.jpg" },
      { url: "https://www.instagram.com/p/DdoxENeMsHx/", views: "36K", likes: "1.7K", thumb: "/reel-aaashishnaik-3.jpg" },
    ],
  },
];

// Cafe / local business reels, ordered best-performing to lesser (per user).
const LOCAL_BUSINESS = [
  { url: "https://www.instagram.com/p/DaFtmQYh-8O/", views: "251K", likes: null, thumb: "/reel-cafe-1.jpg" },
  { url: "https://www.instagram.com/p/DX4N13mKAYH/", views: "138K", likes: null, thumb: "/reel-cafe-2.jpg" },
  { url: "https://www.instagram.com/p/DavCWRNBO-I/", views: "150K", likes: null, thumb: "/reel-cafe-3.jpg" },
  { url: "https://www.instagram.com/p/DVdzjr3Egch/", views: "127K", likes: null, thumb: "/reel-cafe-4.jpg" },
  { url: "https://www.instagram.com/p/DPZAl6djLZR/", views: "112K", likes: null, thumb: "/reel-cafe-5.jpg" },
];

const DigicamReel = ({ reel, index, testid, delay = 0 }) => (
  <motion.a
    data-testid={testid}
    href={reel.url}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: EASE }}
    className="group block select-none outline-none"
  >
    <div className="glass-tile rounded-[16px] p-[6px] transition-all duration-500 ease-out group-hover:-translate-y-1.5 group-hover:-rotate-1 group-hover:shadow-[0_26px_42px_-18px_rgba(13,13,13,0.45)]">
      <div className="rounded-[8px] bg-[#101010] p-[5px] shadow-[inset_0_1px_3px_rgba(0,0,0,0.9)]">
        <div className="relative aspect-[9/13] overflow-hidden rounded-[3px] bg-[#1a1a1a]">
          {reel.thumb && (
            <img
              src={reel.thumb}
              alt=""
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
            />
          )}
          <span className="absolute inset-x-0 top-0 h-14 bg-gradient-to-b from-black/60 to-transparent" />
          <span className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/85 to-transparent" />
          <div className="absolute inset-x-0 top-0 flex items-start justify-between p-3">
            <span className="font-mono-label text-[8px] tracking-[0.25em] text-[#F4F3EF]/80">
              REEL&nbsp;{String(index + 1).padStart(2, "0")}
            </span>
            <ArrowUpRight
              size={13}
              className="-translate-x-1 text-[#F4F3EF] opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100"
            />
          </div>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-[#F4F3EF]/80 text-[#F4F3EF] opacity-80 transition-transform duration-500 group-hover:scale-110">
              <Play size={14} fill="currentColor" className="ml-0.5" />
            </span>
          </div>
          <div className="absolute inset-x-0 bottom-0 space-y-1 p-3">
            <p className="flex items-center gap-1.5 font-helvetica text-lg font-bold tracking-tight text-[#F4F3EF]">
              <Eye size={13} className="opacity-60" />
              {reel.views ?? "—"}
            </p>
            {reel.likes && (
              <p className="flex items-center gap-1.5 font-mono-label text-[9px] tracking-[0.2em] text-[#F4F3EF]/70">
                <Heart size={10} />
                {reel.likes}&nbsp;LIKES
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="mt-[5px] flex items-center justify-between px-[4px] pb-[2px]">
        <span
          className="block h-[11px] w-[11px] rounded-full shadow-[inset_0_1px_2px_rgba(255,255,255,0.9),0_1px_2px_rgba(0,0,0,0.35)]"
          style={{
            background:
              "conic-gradient(from 210deg,#d8d8d5,#9a9a97,#e9e9e6,#a5a5a2,#d8d8d5)",
          }}
        />
        <span
          className="block h-[5px] w-[5px] rounded-full shadow-[inset_0_1px_1px_rgba(255,255,255,0.8)]"
          style={{ background: "radial-gradient(circle at 35% 30%,#f0f0ee,#8f8f8c)" }}
        />
        <span className="block h-[8px] w-[3px] rounded-[2px] bg-[#8d8d8a] shadow-[inset_0_1px_1px_rgba(255,255,255,0.7)]" />
      </div>
    </div>
  </motion.a>
);

const ProfileBanner = ({ client, testid }) => (
  <motion.a
    data-testid={testid}
    href={client.profile}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, ease: EASE }}
    className="group relative block w-full max-w-xl select-none"
  >
    <div className="glass-tile rounded-[18px] p-[6px] transition-all duration-500 ease-out group-hover:-translate-y-1 group-hover:shadow-[0_26px_42px_-18px_rgba(13,13,13,0.4)]">
      <div className="relative overflow-hidden rounded-[12px] bg-[#0D0D0D]">
        <img
          src={client.screenshot}
          alt={`${client.handle} Instagram profile`}
          className="w-full transition-transform duration-700 ease-out group-hover:scale-[1.02]"
        />
        <span className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/70 to-transparent" />
        <span className="absolute bottom-4 right-5 flex items-center gap-1.5 font-mono-label text-[9px] tracking-[0.25em] text-[#F4F3EF]/90">
          VIEW PROFILE
          <ArrowUpRight
            size={12}
            className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
          />
        </span>
      </div>
    </div>
  </motion.a>
);

const SubLabel = ({ children, testid }) => (
  <motion.p
    data-testid={testid}
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, ease: EASE }}
    className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#8C8B85]"
  >
    {children}
  </motion.p>
);

export default function Gallery() {
  return (
    <section
      id="work"
      data-testid="gallery-section"
      className="px-6 py-24 sm:px-10 sm:py-32"
    >
      <div className="mx-auto max-w-[1400px]">
        <motion.p
          data-testid="gallery-eyebrow"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#4A4944] sm:text-xs"
        >
          (03) — Selected work
        </motion.p>
        <motion.h2
          data-testid="gallery-heading"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
          className="mt-6 font-helvetica text-5xl font-bold tracking-tight text-[#0D0D0D] sm:text-6xl lg:text-7xl"
        >
          OUR WORK
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
          className="mt-4 max-w-md font-helvetica text-sm leading-relaxed text-[#4A4944]"
        >
          Personal brands &amp; local businesses — tap any camera to watch the
          reel on Instagram.
        </motion.p>

        <div data-testid="work-subsection-personal-brand" className="mt-16">
          <SubLabel testid="work-label-personal-brand">01 — Personal brand</SubLabel>
          <motion.h3
            data-testid="work-heading-personal-brand"
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="mt-5 font-helvetica text-4xl font-bold tracking-tight text-[#0D0D0D] sm:text-5xl lg:text-6xl"
          >
            PERSONAL BRAND
          </motion.h3>
          {PERSONAL_BRAND.map((client) => (
            <div key={client.handle} className="mt-8">
              <ProfileBanner
                client={client}
                testid={`profile-banner-${client.handle.slice(1)}`}
              />
              <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-5 lg:grid-cols-4">
                {client.reels.map((reel, i) => (
                  <DigicamReel
                    key={reel.url}
                    reel={reel}
                    index={i}
                    delay={0.08 * (i + 1)}
                    testid={`reel-card-${client.handle.slice(1)}-${i + 1}`}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        <div data-testid="work-subsection-local-business" className="mt-24">
          <SubLabel testid="work-label-local-business">
            02 — Local businesses
          </SubLabel>
          <motion.h3
            data-testid="work-heading-local-business"
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
            className="mt-5 font-helvetica text-4xl font-bold tracking-tight text-[#0D0D0D] sm:text-5xl lg:text-6xl"
          >
            LOCAL BUSINESSES
          </motion.h3>
          <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 sm:gap-5 lg:grid-cols-5">
            {LOCAL_BUSINESS.map((reel, i) => (
              <DigicamReel
                key={reel.url}
                reel={reel}
                index={i}
                delay={0.06 * i}
                testid={`reel-card-local-${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
